<template>
  <div>
    <a href="https://www.google.com/search?tbm=isch&q=cat" target="_blank"
      >Find a cat</a
    >
  </div>
</template>

<script>
export default {
  methods: {
    findImage() {
      // https://www.google.com/search?tbm=isch&q=
    },
  },
};
</script>
